export class Po {
    poid: number;
    ponumber: string; //poNumber is a name of the input field
    podate: Date;      //poDate is a name of the input field 
    requesterid: number;
    departmentid: number;
    vendorid: number;
	vendorname: string;
	vendoraddress: string;
    massage: string;
    itemcount: number;	
	itemlist:Array<any>;
	totalvalue:number;
	totalgst:number;
    grandtotal: number;
    paymenttermdays: number;
	notetovendor: string;
	poitem:Array<any>;
    description:string;
    pofilepath:string;
    pofileuploadstatus:number;
	statusid: number;
    createon: Date;
	createdby:number;
	createdbyname: string;
	deliverydate:Date;
	paymenttermid :number;
    modifiedon: Date;
	isdeleted:number;
	currencyname: string;
	gstno:string;
	egstin:string;
	hsncode:string;
    modifiedby: number;
	refdocumentpath: string;
	remarks: string;
	penaltyclause: string;
	currencyid: number;
	entityid: number;
	entityname: string;
	requestername: string;
	vendormailid: string;
	warehouseid: number;
	warehousename: string;
	approvedby: string;
	waddress: string;
	wstate:string;
	wcity:string;
	wpincode:string;
	eaddress: string;
	ecity:string;
	estate:string;
	epincode:string;
	wgstin:string;
	costcenterid : number;
	costcentername : string;
	 active: number;	
	 invoicecount: number;
	
}